export function getDateRangeFromFilter(filter) {
  const start =
    filter?.selectedPeriod?.from ??
    new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);

  const end = filter?.selectedPeriod?.to ?? new Date(Date.now());

  const startDate = `${start.getFullYear()}-${String(
    start.getMonth() + 1
  ).padStart(2, "0")}-${String(start.getDate()).padStart(2, "0")}`;

  const endDate = `${end.getFullYear()}-${String(end.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(end.getDate()).padStart(2, "0")}`;

  return { startDate, endDate };
}

export function getBatchIdFromFilter(filter) {
  return filter?.selectedReportBatchId ?? null;
}

export function getFinalFilter(filter, currentStore) {
  const {startDate, endDate} = getDateRangeFromFilter(filter);
  const itemType = filter.selectedReportItemType
  const inventoryLocation = filter.selectedReportItemLocation
  const isStoreReport = filter.selectedReportFor === 'store'
  const batchId = filter.filterText
  const creditMemoType = filter.selectedReportMemoType
  const saleType = filter.selectedReportSaleType

  let url = ''
  url += isStoreReport ? `store=${currentStore?.name ?? ''}` : 'store=*';
  url += startDate == undefined ? `&start_date=${new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]}` : `&start_date=${startDate}`;
  url += endDate == undefined ? `&end_date=${new Date(Date.now()).toISOString().split('T')[0]}` : `&end_date=${endDate}`;

  if(itemType) {
    const _itemType = itemType == 'all' ? "*" : itemType
    url += `&item_type=${_itemType}&`;
  }

  if(inventoryLocation) {
    url += `&inventory_location=${inventoryLocation}&`;
  }

  if(batchId) {
    url += `&batch_id=${batchId}&`;
  }

  if(creditMemoType) {
    const _creditMemoType = creditMemoType == 'all' ? "*" : creditMemoType
    url += `&credit_memo_type=${_creditMemoType}&`;
  }

  if(saleType) {
    const _saleType = saleType == 'medical and recreational' ? "*" : saleType
    url += `&sale_type=${_saleType}&`;
  }

  return url;
}

export function getReportUrl(report, reportSettings, filter, currentStore) {
  const finalFilter = getFinalFilter(filter, currentStore);
  return `${reportSettings.supersetBaseUrl}/superset/dashboard/${report.slug}/?standalone=1&show_filters=0&expand_filters=0&${finalFilter}`;
}

// native filters... switched to passing url params
// import rison from "rison";

// export function createValueFilter(filterId, columnName, filterValue) {
//   const filterObject = {
//     __cache: {
//       label: `${filterValue}`,
//       validateStatus: false,
//       value: [filterValue],
//     },
//     extraFormData: {
//       filters: [
//         {
//           col: columnName,
//           op: "IN",
//           val: [filterValue],
//         },
//       ],
//     },
//     filterState: {
//       label: `${filterValue}`,
//       validateStatus: false,
//       value: [filterValue],
//     },
//     id: filterId,
//     ownState: {},
//   };

//   const risonString = rison.encode(filterObject);
//   return `${filterId}:${risonString}`;
// }

// export function createDateFilter(filterId, columnName, startDate, endDate) {
//   const filterObject = {
//     __cache: {
//       label: `${startDate} to ${endDate}`,
//       validateStatus: false,
//       value: `${startDate} : ${endDate}`,
//     },
//     extraFormData: {
//       filters: [
//         {
//           col: columnName,
//           op: "TEMPORAL_RANGE",
//           val: `${startDate} : ${endDate}`,
//         },
//       ],
//     },
//     filterState: {
//       label: `${startDate} to ${endDate}`,
//       validateStatus: false,
//       value: `${startDate} : ${endDate}`,
//     },
//     id: filterId,
//     ownState: {},
//   };

//   const risonString = rison.encode(filterObject);
//   return `${filterId}:${risonString}`;
// }


export const supersetHelpers = {
  getBatchIdFromFilter,
  getFinalFilter,
  getReportUrl,
};
